var map = {
	"./database.js": "e86F",
	"./index.js": "vdRI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QA5y";


//////////////////
// WEBPACK FOOTER
// ./store ^\.\/(?!-)[^.]+\.(js)$
// module id = QA5y
// module chunks = 11